module.exports = __webpack_public_path__ + "img/love.b7e5f0df.svg";